<template>
  <div>
    <top-header></top-header>
    <site-header></site-header>
    <inner-banner title="Contact Us" current-page="Contact"></inner-banner>

    <!-- contact page -->
    <section class="w3l-contact py-5" id="contact">
        <div class="container py-md-5 py-4 mb-5">
            <div class="mx-auto" style="max-width:1000px">
                <div class="row contact-block">
                    <div class="col-md-5 contact-left">
                        <h3 class="font-weight-bold mb-md-5 mb-4">Get in touch with us</h3>
                        <div class="cont-details">
                            <div class="d-flex contact-grid">
                                <div class="cont-left text-center mr-3">
                                    <span class="fa fa-globe"></span>
                                </div>
                                <div class="cont-right">
                                    <h6>Company Address</h6>
                                    <p>That's Chinese . Chengdu, Sichuan, China</p>
                                </div>
                            </div>
                            <div class="d-flex contact-grid mt-4 pt-lg-2">
                                <div class="cont-left text-center mr-3">
                                    <span class="fa fa-phone"></span>
                                </div>
                                <div class="cont-right">
                                    <h6>Call Us</h6>
                                    <p><a href="tel:+86 13883135370">+86 13883135370</a></p>
                                </div>
                            </div>
                            <div class="d-flex contact-grid mt-4 pt-lg-2">
                                <div class="cont-left text-center mr-3">
                                    <span class="fa fa-envelope-open"></span>
                                </div>
                                <div class="cont-right">
                                    <h6>Email Us</h6>
                                    <p><a href="mailto:Thatschinese@163.com" class="mail">Thatschinese@163.com</a></p>
                                </div>
                            </div>
                            <div class="d-flex contact-grid mt-4 pt-lg-2">
                                <div class="cont-left text-center mr-3">
                                    <span class="fa fa-headphones"></span>
                                </div>
                                <div class="cont-right">
                                    <h6>Customer Support</h6>
                                    <p><a href="mailto:Thatschinese@163.com" class="mail">Thatschinese@163.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7 mt-md-0 mt-4">
                        <div class="map-iframe">
                            <iframe 
                                width="100%" 
                                height="500" 
                                frameborder="0" 
                                scrolling="no" 
                                marginheight="0" 
                                marginwidth="0" 
                                src="https://www.openstreetmap.org/export/embed.html?bbox=104.064072%2C30.625711%2C104.066072%2C30.627711&amp;layer=mapnik&amp;marker=30.626711%2C104.065072"
                                style="border: 1px solid #ccc">
                            </iframe>
                            <br/>
                            <small>
                                <a href="https://www.openstreetmap.org/?mlat=30.626711&amp;mlon=104.065072#map=18/30.62671/104.06507" target="_blank">
                                    View Larger Map
                                </a>
                            </small>
                        </div>
                    </div> 
                </div>
                <!-- contact form -->
                <!-- <div class="contact-form-sec pt-5 mt-md-5">
                    <div class="title-heading-w3 text-center mx-auto mb-5 pb-sm-4">
                        <h3 class="title-main">We will Answer all your <span>Questions</span></h3>
                    </div>
                    <div class="row contact-block align-items-center">
                        <div class="col-md-5 contact-left">
                            <img src="assets/images/contact.jpg" alt="" class="img-fluid img-responsive">
                        </div>
                        <div class="col-md-7 contact-right mt-md-0 mt-4 pl-lg-4">
                            <form action="https://sendmail.w3layouts.com/submitForm" method="post" class="signin-form">
                                <div class="input-grids">
                                    <input type="text" name="w3lName" id="w3lName" placeholder="Your Name*" class="contact-input" required="" />
                                    <input type="email" name="w3lSender" id="w3lSender" placeholder="Your Email*" class="contact-input" required="" />
                                    <input type="text" name="w3lSubect" id="w3lSubect" placeholder="Subject*" class="contact-input" required="" />
                                </div>
                                <div class="form-input">
                                    <textarea name="w3lMessage" id="w3lMessage" placeholder="Type your message here*" required=""></textarea>
                                </div>
                                <button class="btn btn-style btn-style-secondary mt-sm-3">Send Message</button>
                            </form>
                        </div>
                    </div>
                </div> -->
                <!-- //contact form -->
            </div>
        </div>
    </section>
    <!-- //contact page -->

    <footer-component></footer-component>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import FooterComponent from '@/components/Footer.vue'
import InnerBanner from '@/components/InnerBanner.vue'

export default {
  name: 'ContactPage',
  components: {
    TopHeader,
    SiteHeader,
    FooterComponent,
    InnerBanner
  }
}
</script>

<style scoped>
.map-iframe {
  width: 100%;
  height: 500px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 15px var(--shadow-color);
}

.map-iframe iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.map-iframe small {
  display: block;
  text-align: center;
  margin-top: 5px;
}

.map-iframe small a {
  color: var(--text-secondary);
  text-decoration: none;
}

.map-iframe small a:hover {
  color: var(--primary-color);
}

/* 其他样式保持不变 */
</style> 